/**
 * route-vertrek.ts — wanneer meldt de field-app het vertrek van een route.
 *
 * Het vertrek-verb van de office-app telt alleen op de routedag
 * (VERTREK_NIET_OP_ROUTEDAG). Chauffeurs doen de vertrekcontrole ook bij het
 * laden de avond ervoor (22-10: 14:53 en 19:29 voor routes van 23-10); die
 * klik is geen vertrek. Daarom meldt de app het vertrek niet op het moment
 * van de controle maar zodra de gecontroleerde route op de routedag in beeld
 * is: bij openen, en als de app 's ochtends weer naar de voorgrond komt.
 * Eén melding per route per dag; de server is bovendien idempotent.
 */

/** Kalenderdag in Europe/Amsterdam (YYYY-MM-DD). */
export function vandaagAmsterdam(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam' }).format(now);
}

export interface VertrekMeldStand {
  routeId: string | null;
  /** `Datum__c` van de route (YYYY-MM-DD). */
  routeDatum: string | null;
  vandaag: string;
  /** routeId waarvoor de vertrekcontrole is doorlopen. */
  gecontroleerd: string | null;
  aantalAfgerond: number;
  aantalOpen: number;
  /** sleutel van de laatste melding (`routeId:datum`), of null. */
  alGemeldVoor: string | null;
}

/**
 * Puur: de sleutel van de melding die nu hoort te gaan, of null.
 * Geen melding vóór de routedag, na een eerste afgeronde stop (het anker is
 * dan die stop), zonder open stops, zonder controle, of als hij al ging.
 */
export function moetVertrekMelden(s: VertrekMeldStand): string | null {
  if (!s.routeId || s.gecontroleerd !== s.routeId) return null;
  if (!s.routeDatum || s.routeDatum !== s.vandaag) return null;
  if (s.aantalAfgerond > 0 || s.aantalOpen === 0) return null;
  const sleutel = `${s.routeId}:${s.routeDatum}`;
  return s.alGemeldVoor === sleutel ? null : sleutel;
}
